module.exports = __webpack_public_path__ + "img/yw_thumb.4e105581.gif";